<template>
  <div class="mb-15" v-if="articles && articles.length">
    <v-container tag="section">
      <h2 class="text-h5 secondary--text font-weight-bold mb-7">{{ $t('label.magazines') }}</h2>
      <v-row v-if="!$vuetify.breakpoint.mdAndUp">
        <v-col v-for="article in articles" :key="article.article_id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
          <v-card :ripple="false" :to="{ name: $constants.ROUTE_NAME.ARTICLE_DETAIL, params: { articleId: article.article_id } }">
            <v-img height="180" :src="article.thumbnail" />
            <v-card-title class="pa-3">
              <div class="ellipsis text-caption grey--text text--darken-2" :title="article.title">{{ article.title }}</div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <div v-else class="d-flex" v-dragscroll style="overflow: hidden">
        <v-col v-for="article in articles" :key="article.article_id" cols="4" sm="3" md="2">
          <v-card :ripple="false" :to="{ name: $constants.ROUTE_NAME.ARTICLE_DETAIL, params: { articleId: article.article_id } }">
            <v-img height="180" :src="article.thumbnail" />
            <v-card-title class="pa-3">
              <div class="ellipsis text-caption grey--text text--darken-2" :title="article.title">{{ article.title }}</div>
            </v-card-title>
          </v-card>
        </v-col>
      </div>
    </v-container>
    <Spacer />
    <v-row class="text-center" justify="center">
      <v-col md="3">
        <app-button
          :label="$t('button.readMore')"
          gradient
          invert
          class="text-subtitle-1 px-10 py-5"
          :to="{ name: $constants.ROUTE_NAME.ARTICLE_DETAIL, params: { articleId: articles.length ? articles[0].article_id : 1 } }"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Spacer from '@/components/Spacer.vue'

export default {
  components: { Spacer },
  computed: {
    ...mapGetters('page', ['articles'])
  }
}
</script>

<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  word-break: normal;
}
</style>
